export default __webpack_public_path__ + "static/media/shuttle.753e2e67.svg";